import { type ComponentProps, type FC } from 'react';
import { Drawer } from 'vendor/material';

import {
  MemberInputType,
  MemberInput as MemberInputSchema,
} from '../../referralFormSchema';

import MemberInputForm from './MemberInputForm';

interface AddTeamMemberDrawerProps {
  onAddMember: (member: MemberInputType) => void;
  onClose: () => void;
}

const AddTeamMemberContent = ({
  onAddMember,
  onClose,
}: AddTeamMemberDrawerProps) => {
  const handleAddMember = (member: MemberInputType) => {
    onAddMember(MemberInputSchema.parse(member));
  };

  return <MemberInputForm onSubmit={handleAddMember} onCancel={onClose} />;
};

export const AddTeamMemberFormDrawer: FC<
  ComponentProps<typeof Drawer> & AddTeamMemberDrawerProps
> = ({ open, onAddMember, onClose, ...drawerProps }) => {
  return (
    <Drawer
      data-testid="add-team-member-drawer"
      anchor="right"
      variant="temporary"
      open={open}
      onClose={onClose}
      {...drawerProps}
      children={
        <AddTeamMemberContent onAddMember={onAddMember} onClose={onClose} />
      }
    />
  );
};
